import { render } from "./DynamicRating.vue?vue&type=template&id=105cd214&ts=true"
import script from "./DynamicRating.vue?vue&type=script&lang=ts"
export * from "./DynamicRating.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicRating.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "105cd214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('105cd214', __exports__)) {
    api.reload('105cd214', __exports__)
  }
  
  module.hot.accept("./DynamicRating.vue?vue&type=template&id=105cd214&ts=true", () => {
    api.rerender('105cd214', render)
  })

}


export default __exports__